export default "__VITE_ASSET__tOtemufl__"